import ekumaruRaw from '../../../docs/design-system/assets/ekumaru-avatar.svg?raw';
import xlaboRaw from '../../../docs/design-system/assets/xlabo-symbol.svg?raw';

/**
 * **キャラクターとブランドの素材**（§4.6 / D101 / D120 決定2）。
 *
 * **加工しない** — `CharacterAvatar` は「**加工不要（原本をそのまま使う）**」と
 * 型のコメントに書いてある。**エクマルは色を持つ絵**であり、
 * DADS のアイコン（`currentColor` を継ぐ線画）とは扱いが違う。
 *
 * **`icons/index.ts` と分けてある**のはその区別を消さないためである。
 */
export const EKUMARU_AVATAR = ekumaruRaw;
export const XLABO_SYMBOL = xlaboRaw;
